import { IReduxAction } from './index'
import { REHYDRATE } from 'redux-persist'
import { AppAction, Command } from '../config/appConfig'

export interface IAppState {
    breadcrumbs: string[]
    version: string
    hasAcknowledgedVersion: boolean
    command?: Command | string
}

export const defaultAppState: IAppState = {
    breadcrumbs: [],
    version: '',
    hasAcknowledgedVersion: false,
    command: null,
}

export default function reducer(state: IAppState = defaultAppState, action: IReduxAction): IAppState {
    switch (action.type) {
        case REHYDRATE:
            return { ...defaultAppState, ...action.payload?.app }

        case AppAction.DispatchCommand:
            return { ...state, command: action.payload }

        case AppAction.AcknowledgeCommand:
            return { ...state, command: null }

        case AppAction.SetBreadcrumbs:
            return { ...state, breadcrumbs: action.payload }

        case AppAction.SetVersion:
            return {
                ...state,
                version: action.payload,
                hasAcknowledgedVersion: false,
            }
    }

    return state
}
